import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { tickTimer } from "../store/sessionSlice";
import { Progress, Typography } from "antd";

const { Text } = Typography;

export default function Timer({ questionId, remaining, total, onTimeUp }) {
  const dispatch = useDispatch();
  const pauseflag = useSelector((s) => s.session.pauseflag);

  useEffect(() => {
    if (remaining <= 0) {
      console.log("⏰ TIME UP! Calling onTimeUp()");
      onTimeUp();
      return;
    }

  
    if (pauseflag) {
      console.log("Timer paused ");
      return;
    }

    const timer = setInterval(() => {
      dispatch(tickTimer(questionId));
    }, 1000);

    return () => clearInterval(timer);
  }, [remaining, pauseflag, dispatch, questionId, onTimeUp]);

  const getProgressColor = () => {
    const percentage = (remaining / total) * 100;
    if (percentage > 50) return "#52c41a";
    if (percentage > 25) return "#faad14";
    return "#f5222d";
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Progress
        type="circle"
        percent={(remaining / total) * 100}
        width={40}
        format={() => `${remaining}`}
        strokeColor={getProgressColor()}
      />
      <Text type="secondary" style={{ fontSize: "12px" }}>
        seconds remaining
      </Text>
    </div>
  );
}
